export default "__VITE_ASSET__C_2ijznR__"